/**
 * 監督者關掉過「加入主畫面」的提示。一台裝置問一次就好。
 *
 * 讀寫都包 try：無痕模式或封鎖網站資料時 localStorage 會丟例外，而這只是個提示，
 * 不該因此讓 App 打不開。
 */
const DISMISSED_KEY = "fight-health-install-hint-dismissed-v1";

export function installHintDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissInstallHint(): void {
  try {
    localStorage.setItem(DISMISSED_KEY, "1");
  } catch {
    /* 存不起來就只關這一次 */
  }
}
